var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { TypeActionTournament } from "./actionTournament";
var initial = {
    eventId: 0,
    eventType: undefined,
    leagueId: 0,
    rankingEntry: [],
};
export var reducerLeagueRanking = function (state, action) {
    if (state === void 0) { state = initial; }
    switch (action.type) {
        case TypeActionTournament.LeagueRankingReceived:
            return __assign({}, action.response, { eventType: action.leagueType });
        default:
            return state;
    }
};



//////////////////
// WEBPACK FOOTER
// ./src/features/tournament-building/reducerLeagueRanking.ts
// module id = 2981
// module chunks = 3